export enum UploadStatus {
	PENDING = "PENDING",
	UPLOADING = "UPLOADING",
	ANALYZING = "ANALYZING",
	COMPLETED = "COMPLETED",
	UPLOADING_ERROR = "UPLOADING-ERROR",
	ANALYZING_ERROR = "ANALYZING-ERROR",
}
